import React from 'react';
import HeaderComponent from './HeaderComponent';
import FeatureNav from './FeatureNav';
import HeroComponent from './HeroComponent';
import ImageWithQuoteSection from './ImageWithQuoteSection';
import QuickTools from './QuickTools';
import FeaturedDataStories from './FeaturedDataStories';
import LearnSection from './LearnSection';
import TaxpayersTakeaway from './TaxpayersTakeaway';
import DataCategoriesAndTools from './DataCategoriesAndTools';
import HowToVideos from './HowToVideos';
import FooterSection from './FooterSection';
import ThankfulForTransparency from './ThankfulForTransparency';
import RevExIFrame from './RevExIFrame';
import MIDAButton from './MIDAButton';

const HomePage = () => {
  return (
    <div>
        <HeaderComponent/>
        <FeatureNav />
        <HeroComponent />
        <MIDAButton />
        <RevExIFrame />
        <QuickTools />
        <ImageWithQuoteSection />
        <ThankfulForTransparency />
        <FeaturedDataStories />
        <LearnSection />
        <DataCategoriesAndTools />
        <TaxpayersTakeaway />
        <HowToVideos />
        <FooterSection />
    </div>
  )
}

export default HomePage